import { TrackEvent } from "../../utils/analytics.ts";

export const socialLogin = async (
  request: RequestInit,
  loginType: "email" | "facebook" | "google" | "apple",
): Promise<number> => {
  const response = await fetch("/users/sociallogin", request);
  if (response.ok) {
    const method: "email" | "facebook" | "google" | "apple" = loginType;
    // If the response status is 201, a new account was created, and the user is redirected to the welcome page
    if (response.status === 201) {
      TrackEvent({ name: "sign_up", method: method });
      TrackEvent({ name: "my_espc_account_activated", value: 50 });
      return response.status;
    } else {
      TrackEvent({ name: "login", method: method });
      return response.status;
    }
  } else {
    throw new Error("Social login failed");
  }
};
